import React from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import museumsData from "./museumsData";

function MuseumDetails() {
  const { museumId } = useParams();
  const selectedLang = useSelector((state) => state.language.selectedLang);

  const museum = museumsData.find((m) => m.id === museumId);
  if (!museum) return <div>Museum not found</div>;

  const t = museum.content[selectedLang];

  return (
    <div className="bg-[#F6F6EC] px-4 py-12">
      {/* Title */}
      <div className="text-center mb-8">
        <h1 className="text-[26px] sm:text-4xl md:text-5xl lg:text-[45px] text-black">
          {t.title}
        </h1>
        <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
          <span style={{ color: "#DD9827" }}>
            <Link to="/" className="hover:underline">
              {t.breadcrumbHome}
            </Link>{" "}
            /{" "}
            <Link
              to="/museums"
              className="hover:underline"
              style={{ color: "#DD9827" }}
            >
              {t.breadcrumbMuseum}
            </Link>{" "}
            /{" "}
          </span>
          <span className="uppercase">{t.title}</span>
        </p>
      </div>

      {/* Image + Ticket + Description */}
      <div className="flex flex-col lg:flex-row gap-10 max-w-7xl mx-auto px-4 lg:px-16 py-6">
        {/* Left Image Box */}
        <div className="bg-[#EFEDE0] border-2 border-[#F8D6BF] rounded-[34px] p-4 w-full max-w-md mx-auto lg:mx-0 text-center self-start">
          <img
            src={museum.image}
            alt="Museum"
            className="w-full h-[290px] rounded-[34px] object-cover"
          />
          <p className="mt-4 text-base md:text-lg">
            <span
              style={{
                textShadow: "0.3px 0.3px 0 black",
                letterSpacing: "0.05rem",
              }}
            >
              {t.place}
            </span>{" "}
            {t.place2} <br />
            <span
              style={{
                textShadow: "0.3px 0.3px 0 black",
                letterSpacing: "0.05rem",
              }}
            >
              {t.imgtitle}
            </span>{" "}
            {t.imgtitle1}
            <br />
            <span
              style={{
                textShadow: "0.3px 0.3px 0 black",
                letterSpacing: "0.05rem",
              }}
            >
              {t.imgtitle2}
            </span>{" "}
            {t.imgtitle3} <br />
            <span
              style={{
                textShadow: "0.3px 0.3px 0 black",
                letterSpacing: "0.05rem",
              }}
            >
              {t.date}
            </span>{" "}
            <br />
            {t.date1}
          </p>
        </div>

        {/* Ticket + Description */}
        <div className="w-full flex flex-col gap-6">
          {/* Ticket Box */}
          <div className="bg-[#EFEDE0] shadow-md rounded-[24px] p-6">
            <h2 className="text-2xl font-semibold text-center mb-4">
              {t.paragraphtitle}
            </h2>
            <ul className="text-base text-[14px] sm:text-lg md:text-xl lg:text-[20px] space-y-4 text-left">
              {/* Line 1 */}
              <li className="grid grid-cols-[1fr_auto] gap-4">
                <span>{t.title1}</span>
                <span className="text-left">{t.subtitle1}</span>
              </li>

              {/* Line 2 */}
              <li className="grid grid-cols-[1fr_auto] gap-4">
                <span>{t.title2}</span>
                <span className="text-left">{t.subtitle2}</span>
              </li>

              {/* Line 3 with brackets in second line */}
              <li className="grid grid-cols-[1fr_auto] gap-4">
                <div className="flex flex-col">
                  <span>{t.title3}</span>
                  <span className="">
                    {t.title33}
                  </span>
                </div>
                <span className="text-left">{t.subtitle3}</span>
              </li>

              {/* Line 4 */}
              <li className="grid grid-cols-[1fr_auto] gap-4">
                <span>{t.title4}</span>
                <span className="text-left">{t.subtitle4}</span>
              </li>
            </ul>
          </div>

          {/* Description */}
          <div className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem] text-justify font-futura">
            <p className="mb-4">{t.paragraph1}</p>
            <p className="mb-4">{t.paragraph2}</p>
            <p className="mb-4">{t.paragraph3}</p>
            <p className="mb-4">{t.paragraph4}</p>
            <p className="mb-4">{t.paragraph5}</p>
            <p className="mb-4">{t.paragraph6}</p>
            <p>{t.paragraph7}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MuseumDetails;
